import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-600 text-base">持续更新论坛访问相关的最新教程和路线信息</p>
          </div>
          <Link
            to="/category/latest-routes"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium">
                  {article.categoryName}
                </span>
                <span className="text-xs text-foreground-500">{article.readTime} 分钟阅读</span>
              </div>
              <h3 className="text-base font-semibold font-heading text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2 flex-1">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between pt-4 border-t border-background-200/70 mt-auto">
                <span className="text-xs text-foreground-500">{article.publishedAt}</span>
                <span className="text-xs text-primary-600 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                  阅读全文
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}